/**
 * @generated SignedSource<<8cea9d05e25ec92efa94c5c72c987e05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accountsPage_MergeMutation$variables = {
  action: string;
  bankAccountId?: string | null | undefined;
  qboAccountQboId: string;
};
export type accountsPage_MergeMutation$data = {
  readonly sourcingAccountMerge: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly job: {
      readonly jobId: number;
      readonly status: string;
    } | null | undefined;
    readonly ok: boolean;
    readonly preview: {
      readonly claimed: number;
      readonly demoted: number;
      readonly flagged: number;
      readonly matched: number;
      readonly pending: number;
    } | null | undefined;
  } | null | undefined;
};
export type accountsPage_MergeMutation = {
  response: accountsPage_MergeMutation$data;
  variables: accountsPage_MergeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bankAccountId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "qboAccountQboId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "action",
    "variableName": "action"
  },
  {
    "kind": "Variable",
    "name": "bankAccountId",
    "variableName": "bankAccountId"
  },
  {
    "kind": "Variable",
    "name": "qboAccountQboId",
    "variableName": "qboAccountQboId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matched",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "claimed",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagged",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demoted",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pending",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "job",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountsPage_MergeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SourcingAccountMergeMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingAccountMerge",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingMergePreview",
            "kind": "LinkedField",
            "name": "preview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "accountsPage_MergeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SourcingAccountMergeMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingAccountMerge",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingMergePreview",
            "kind": "LinkedField",
            "name": "preview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25f7eea07cd3913fba0cff0852ae08f0",
    "id": null,
    "metadata": {},
    "name": "accountsPage_MergeMutation",
    "operationKind": "mutation",
    "text": "mutation accountsPage_MergeMutation(\n  $action: String!\n  $qboAccountQboId: String!\n  $bankAccountId: ID\n) {\n  sourcingAccountMerge(action: $action, qboAccountQboId: $qboAccountQboId, bankAccountId: $bankAccountId) {\n    ok\n    preview {\n      matched\n      claimed\n      flagged\n      demoted\n      pending\n      id\n    }\n    job {\n      jobId\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c6d910a20d2a0fdf33d70b81b1634f7";

export default node;
